import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets the scroll position to the top of the page whenever the route changes.
 * If the URL has a hash (e.g. /book-consultation#booking-form) we leave it alone
 * so the browser handles the anchor scroll natively.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // intentional anchor link
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
